// Mock data for The Sport Bloc

export const locations = [
  {
    id: 1,
    name: 'Football Arena',
    sport: 'Futsal',
    sportIcon: '/soccer-icon.svg',
    address: 'Shillong, Meghalaya',
    description: 'Professional futsal turf with top-quality facilities',
    image: '/images/football-arena.jpg',
    heroImage: '/images/football-arena.jpg',
    features: [
      'Climate-controlled indoor futsal field',
      'Professional grade artificial turf',
      '5v5 and 7v7 formats available',
      'Floodlit for night matches'
    ],
    amenities: [
      { name: 'Parking', icon: '🅿️', description: 'Space for 15-20 cars with security' },
      { name: 'Food & Drink', icon: '🍔', description: 'In-house cafe with refreshments' },
      { name: 'Sports Store', icon: '👟', description: 'Buy/rent football boots and equipment' },
      { name: 'Changing Rooms', icon: '👕', description: 'Clean changing facilities' },
      { name: 'Toilets', icon: '🚻', description: 'Separate facilities for males and females' },
      { name: 'Spectator Area', icon: '👥', description: 'Comfortable seating for families' }
    ],
    pricing: {
      weekday: 2000,
      weekend: 2500,
      hourly: true
    },
    timings: '6:00 AM - 11:00 PM',
    contact: '+91 98765 43210'
  },
  {
    id: 2,
    name: 'Racquet Sports Arena',
    sport: 'Pickleball',
    sportIcon: '/pickleball-icon.svg',
    address: 'Shillong, Meghalaya',
    description: 'Premium pickleball courts for all skill levels',
    image: '/images/pickleball-equipment.jpg',
    heroImage: '/images/pickleball-equipment.jpg',
    features: [
      'International standard pickleball courts',
      'Quality court surface',
      'Equipment rental available',
      'Well-maintained facilities'
    ],
    amenities: [
      { name: 'Parking', icon: '🅿️', description: 'Ample parking space' },
      { name: 'Food & Drink', icon: '☕', description: 'Refreshment counter' },
      { name: 'Sports Store', icon: '🏓', description: 'Buy/rent paddles and balls' },
      { name: 'Changing Rooms', icon: '👕', description: 'Modern changing facilities' },
      { name: 'Toilets', icon: '🚻', description: 'Clean washroom facilities' },
      { name: 'Spectator Area', icon: '🪑', description: 'Viewing area with seating' }
    ],
    pricing: {
      weekday: 800,
      weekend: 1000,
      hourly: true
    },
    timings: '6:00 AM - 10:00 PM',
    contact: '+91 98765 43211'
  }
];

export const timeSlots = [
  { id: 1, time: '06:00 AM - 07:00 AM', available: true },
  { id: 2, time: '07:00 AM - 08:00 AM', available: true },
  { id: 3, time: '08:00 AM - 09:00 AM', available: false },
  { id: 4, time: '09:00 AM - 10:00 AM', available: true },
  { id: 5, time: '10:00 AM - 11:00 AM', available: true },
  { id: 6, time: '11:00 AM - 12:00 PM', available: false },
  { id: 7, time: '12:00 PM - 01:00 PM', available: true },
  { id: 8, time: '01:00 PM - 02:00 PM', available: true },
  { id: 9, time: '02:00 PM - 03:00 PM', available: true },
  { id: 10, time: '03:00 PM - 04:00 PM', available: true },
  { id: 11, time: '04:00 PM - 05:00 PM', available: false },
  { id: 12, time: '05:00 PM - 06:00 PM', available: true },
  { id: 13, time: '06:00 PM - 07:00 PM', available: false },
  { id: 14, time: '07:00 PM - 08:00 PM', available: true },
  { id: 15, time: '08:00 PM - 09:00 PM', available: true },
  { id: 16, time: '09:00 PM - 10:00 PM', available: true }
];

export const storeItems = [
  {
    id: 1,
    name: 'Football Boots',
    category: 'Footwear',
    price: 2500,
    rental: 200,
    image: 'https://images.unsplash.com/photo-1511886929837-354d827aae26?w=400',
    available: true,
    locationId: 1
  },
  {
    id: 2,
    name: 'Training Bibs',
    category: 'Apparel',
    price: 300,
    rental: 50,
    image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400',
    available: true,
    locationId: 1
  },
  {
    id: 3,
    name: 'Pickleball Paddle',
    category: 'Equipment',
    price: 3500,
    rental: 150,
    image: 'https://images.pexels.com/photos/6253919/pexels-photo-6253919.jpeg?w=400',
    available: true,
    locationId: 2
  },
  {
    id: 4,
    name: 'Pickleball Set (4 balls)',
    category: 'Equipment',
    price: 800,
    rental: 100,
    image: 'https://images.pexels.com/photos/5069172/pexels-photo-5069172.jpeg?w=400',
    available: true,
    locationId: 2
  }
];

export const galleryImages = [
  {
    id: 1,
    url: '/images/football-arena.jpg',
    title: 'Football Arena - Indoor Turf',
    locationId: 1
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=600',
    title: 'Football Arena - Night Play',
    locationId: 1
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?w=600',
    title: 'Football Arena - Action',
    locationId: 1
  },
  {
    id: 4,
    url: '/images/pickleball-ball.jpg',
    title: 'Racquet Sports - Pickleball',
    locationId: 2
  },
  {
    id: 5,
    url: '/images/pickleball-equipment.jpg',
    title: 'Racquet Sports - Equipment',
    locationId: 2
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/6253925/pexels-photo-6253925.jpeg?w=600',
    title: 'Racquet Sports - Facilities',
    locationId: 2
  }
];